import React from 'react'
import Share from '../Share'
import { MDXRenderer } from "gatsby-plugin-mdx"
import startCase from 'lodash/startCase'
import Adsense from '../Adsense'
import './Article.scss'

class Article extends React.Component {
  render () {
    const post = this.props.post
    const siteMeta = this.props.siteMeta

    return (
      <article
        itemScope
        itemType="https://schema.org/Article"
        className="page-content"
      >
        <header className="page-header">
          <div className="page-header-text">
            <h1 className="page-header-title" itemProp="headline">
              {post.frontmatter.title}
            </h1>
            <span className="page-header-author">{post.frontmatter.author || siteMeta.author}</span>
            {post.frontmatter.categories ? 
              <span className="page-header-category">
                <a href={`/categories/${post.frontmatter.categories[0]}/`}>{startCase(post.frontmatter.categories[0])}</a>
              </span>
            : null}
            <span className="page-header-date" itemProp="datePublished">
                { this.props.post.frontmatter.date }
            </span>
            <span className="page-header-reading-time">
              {post.timeToRead} mins read
            </span>
          </div>
        </header>
        <section className="page-body" itemProp="articleBody">
          <MDXRenderer>{post.body}</MDXRenderer>
        </section>
        <div className="article-ad">
            <Adsense type="article-bottom"/>
        </div>
        <Share title={post.frontmatter.title} pathname={post.fields.slug}/>
        <Adsense type="matched-content"/>
      </article>
    )
  }
}

export default Article
